import commonFunction from '../common/common';
import Handlebars from 'handlebars';
const Uppy = require('uppy');
import moment from 'moment';
import sourceFile from '../../config/config.js';
const _ = require('underscore');
const rootDir = sourceFile.rootDir;
const apiUrl = sourceFile.url;
var fetched = false;
var $imageUploadModal;
// var dbAuthToken = sourceFile.dbAuthToken;
var dbAuthToken = hfUploadToken.value
var uppy;
var allowedExtArr = [];
var pluginUrl = sourceFile.hfPluginUrl;
var imageUploadMarkup = `<div class="image-upload-overlay hide" id="imageUploadModal" tabindex="0">
            <div class="image-upload-modal">
                <div class="left image-dir">
                    <!-- <div class="image-modal-head">
                        <div class="upload-image-btn">
                            <span class="add-icon">+</span>
                            <span class="upload-image">Upload Files</span>
                        </div>
                    </div> -->
                    <div class="image-category gallery selected">Gallery</div>
        <div class="image-category documents hide">Documents</div>
                    <div class="image-category unsplash">Unsplash</div>
                    <div class="image-category icon-finder">Icons</div>
                    <div class="image-category upload">Import Files</div>
                </div>
    <div class="right image-listing documents hide">
        <div class="image-modal-head">
<div class="search-box">
  <span class="search-icon">
    <img src="static/images/Search icon.svg">
  </span>
  <input type="text" class="search-image" placeholder="Search files">
  <span class="close-icon hide">
    <img src="static/images/Close.svg">
  </span>
</div>
<div class="copy-images hide copy-link" data-tooltip="Copy link" data-position="left center"
  data-variation="tiny" data-inverted><img src="/app/src/images/tree-view/copy.svg"
    title="Copy Formula"></div>
<div class="copy-images hide function-btn">Done</div>
</div>
        <div class="image-list">
<div class="uploaded-images">
  <div class="modal-content image-loader">
    <img src="static/images/Console/loader.svg" style="width: 250px;height: 250px;">
    <div class="loader-text">Loading Data...</div>
  </div>
</div>
</div>
    </div>
    <!-- doc listing -->
                <div class="right image-listing gallery">
                    <div class="image-modal-head">
                        <div class="search-box">
                            <span class="search-icon">
                                <img src="${rootDir}/assets/icons/Search icon.svg">
                            </span>
                            <input type="text" class="search-image" placeholder="Search files">
                            <span class="close-icon hide">
                                <img src="${rootDir}/assets/icons/Close.svg">
                            </span>
                        </div>
                        <div class="copy-images hide copy-link" data-tooltip="Copy link" data-position="left center"  data-variation="tiny" data-inverted>
                          <img src="${rootDir}/assets/icons/copy.svg" title="Copy Formula">
                        </div>
                        <div class="copy-images hide function-btn">Done</div>
                    </div>
                    <div class="image-list">
                        <div class="files-title">Gallery</div>
                        <div class="uploaded-images">
                            <div class="modal-content image-loader">
                                <img src="${rootDir}/assets/icons/loader.svg" style="width: 250px;height: 250px;">
                                <div class="loader-text">Loading Data...</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right image-listing unsplash import hide">
                    <div class="image-modal-head">
                        <div class="search-box">
                            <span class="search-icon">
                                <img src="${rootDir}/assets/icons/Search icon.svg">
                            </span>
                            <input type="text" class="search-image" placeholder="Search for images">
                            <span class="close-icon hide">
                                <img src="${rootDir}/assets/icons/Close.svg">
                            </span>
                        </div>
                        <div class="search-btn">Search</div>
                        <div class="ui button import-images hide">Import</div>
                    </div>
                    <div class="image-list">
                        <div class="uploaded-images">
                            <div class="modal-content image-loader">
                                <img src="${rootDir}/assets/icons/loader.svg" style="width: 250px;height: 250px;">
                                <div class="loader-text">Loading Data...</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right image-listing icon-finder import hide">
                    <div class="image-modal-head">
                        <div class="search-box">
                            <span class="search-icon">
                                <img src="${rootDir}/assets/icons/Search icon.svg">
                            </span>
                            <input type="text" class="search-image" placeholder="Search for images">
                            <span class="close-icon hide">
                                <img src="${rootDir}/assets/icons/Close.svg">
                            </span>
                        </div>
                        <div class="search-btn">Search</div>
                        <div class="ui button import-images hide">Import</div>
                    </div>
                    <div class="image-list">
                        <div class="uploaded-images">
                            <div class="image-placeholder unsplash">
                                <img src="${rootDir}/assets/icons/emptyList.svg" class="no-data-img">
                                <span class="no-data-caption">Search content!</span>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="close-gallery">
                    <img src="${rootDir}/assets/icons/Close.svg">
                </span>	
            </div>
            <div class="upload-pic-overlay hide">
                <div class="picture-upload-modal">
                    <div class="left image-sidebar">
                        <div class="upload-type system selected">
                            <img src="${rootDir}/assets/icons/system.svg">
                        </div>
                        <div class="upload-type url">
                            <img src="${rootDir}/assets/icons/link.svg">
                        </div>
                    </div>
                    <div class="right image-uploader">
                        <div class="import system" id="import-image">
                        </div>
                        <div class="import url hide">
                            <div class="add-image">
                                <div class="add-image-icon">
                                    <img src="${rootDir}/assets/icons/Image Upload.svg" onerror="this.src='${rootDir}/assets/icons/Image Upload.svg';" style=" width: 120px; ">	
                                </div>
                                <div class="add-image-detail">Import a file from URL</div>
                                <input type="text" placeholder="Paste your link here..." class="image-url">
                                <div class="error-message hide url-import">Error! Image not found!</div>
                                <div class="link-button">
                                    <div class="import-link ui button ">Import</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span class="close-upload">
                        <img src="${rootDir}/assets/icons/Close.svg">
                    </span>
                </div>
            </div>
        </div>`;

var appendHtml = function () {
  $('body').append(imageUploadMarkup);
  $imageUploadModal = $('#imageUploadModal');
};

var clickEventInit = function () {
  $imageUploadModal.find('.close-gallery').click(function () {
    $imageUploadModal.addClass('hide');
  });

  $imageUploadModal.find('.picture-upload-modal .upload-type.system').click(function () {
    $imageUploadModal.find('.picture-upload-modal .upload-type').removeClass('selected');
    $(this).addClass('selected');
    $imageUploadModal.find('.picture-upload-modal .import.system').removeClass('hide');
    $imageUploadModal.find('.picture-upload-modal .import.url').addClass('hide')
  })

  $imageUploadModal.find('.picture-upload-modal .upload-type.url').click(function () {
    $imageUploadModal.find('.picture-upload-modal .upload-type').removeClass('selected');
    $(this).addClass('selected');
    $imageUploadModal.find('.picture-upload-modal .import.url').removeClass('hide');
    $imageUploadModal.find('.picture-upload-modal .import.system').addClass('hide')
  })

  $imageUploadModal.find('.image-category.upload').click(function () {
    $imageUploadModal.find('.upload-pic-overlay').removeClass('hide');
  })

  $imageUploadModal.find('.close-upload').click(function () {
    $imageUploadModal.find('.upload-pic-overlay').addClass('hide');
  })

  $imageUploadModal.find('.image-listing.gallery .search-box input.search-image').keyup(function () {
    var searchTerm = $(this).val().toLowerCase().trim();
    let $parentListing = $(this).parents(".image-listing.gallery")
    if (searchTerm !== "") {
      $parentListing.find('.search-box .close-icon').removeClass('hide');
      let allowedFile = allowedExtArr.map(element => { return element.toLowerCase() });
      $parentListing.find('.uploaded-images .image-tile').each(function () {
        var url = $(this).data('url').split(".")
        var ext = url[url.length - 1]
        let fileRestriction = allowedFile && allowedFile.length ? allowedFile.includes(ext) : true
        if (fileRestriction) {
          if ($(this).data('filename').toLowerCase().indexOf(searchTerm) == -1) {
            $(this).addClass('hide');
          } else {
            $(this).removeClass('hide');
          }
        } else {
          $(this).addClass('hide');

        }
      })
    } else {
      $parentListing.find('.search-box .close-icon').addClass('hide');
      displyFilteredTile(allowedExtArr)
    }
    if ($parentListing.find('.uploaded-images .image-tile:not(.hide)').length == 0) {
      $parentListing.find('.no-data-present').removeClass('hide');
    } else {
      $parentListing.find('.no-data-present').addClass('hide');
    }
  });
  $imageUploadModal.find('.image-listing.documents .search-box input.search-image').keyup(function () {
    var searchTerm = $(this).val().toLowerCase().trim();
    let $parentListing = $(this).parents(".image-listing")
    if (searchTerm !== "") {
      $parentListing.find('.search-box .close-icon').removeClass('hide');
      let allowedFile = allowedExtArr.map(element => { return element.toLowerCase() });
      $parentListing.find('.uploaded-images .image-tile').each(function () {
        var url = $(this).data('url').split(".")
        var ext = "." + url[url.length - 1]
        let fileRestriction = allowedFile && allowedFile.length ? allowedFile.includes(ext) : true
        if (fileRestriction) {
          if ($(this).data('filename').toLowerCase().indexOf(searchTerm) == -1) {
            $(this).addClass('hide');
          } else {
            $(this).removeClass('hide');
          }
        } else {
          $(this).addClass('hide');
        }
      })
    } else {
      $parentListing.find('.search-box .close-icon').addClass('hide');
      displyFilteredTile(allowedExtArr)
    }
    if ($parentListing.find('.uploaded-images .image-tile:not(.hide)').length == 0) {
      $parentListing.find('.no-data-present').removeClass('hide');
    } else {
      $parentListing.find('.no-data-present').addClass('hide');
    }
  });

  $imageUploadModal.find('.image-listing.unsplash .search-box input.search-image').keyup(function (e) {
    if (e.keyCode == 13) {
      $imageUploadModal.find('.image-listing.unsplash .image-modal-head .search-btn').click();
    }
    if ($(this).val().trim() != "") {
      $imageUploadModal.find('.image-listing.unsplash .search-box .close-icon').removeClass('hide');
    } else {
      $imageUploadModal.find('.image-listing.unsplash .search-box .close-icon').addClass('hide');
      $imageUploadModal.find('.image-listing.unsplash .uploaded-images .image-tile').removeClass("hide")
    }
  });

  $imageUploadModal.find('.image-listing.unsplash .image-modal-head .search-btn').click(function () {
    var searchTerm = $imageUploadModal.find('.image-listing.unsplash .image-modal-head .search-box input').val();
    if(searchTerm.trim() != ""){
      var $loader = `<div class="modal-content image-loader">
                                  <img src="static/images/Console/loader.svg" style="width: 250px;height: 250px;">
                                  <div class="loader-text">Loading Data...</div>
                              </div>`
      $imageUploadModal.find('.image-listing.unsplash .uploaded-images').html($loader)
      fnFetchUnsplashImages(searchTerm);
    }
  })

  $imageUploadModal.find('.image-listing.icon-finder .search-box input.search-image').keyup(function (e) {
    if (e.keyCode == 13) {
      $imageUploadModal.find('.image-listing.icon-finder .image-modal-head .search-btn').click();
    }
    if ($(this).val() !== "") {
      $imageUploadModal.find('.image-listing.icon-finder .search-box .close-icon').removeClass('hide');
    } else {
      $imageUploadModal.find('.image-listing.icon-finder .search-box .close-icon').addClass('hide');
    }
  });

  $imageUploadModal.find('.image-listing.icon-finder .image-modal-head .search-btn').click(function () {
    var $loader = `<div class="modal-content image-loader">
                                <img src="static/images/Console/loader.svg" style="width: 250px;height: 250px;">
                                <div class="loader-text">Loading Data...</div>
                            </div>`
    var $empty = `<div class="no-data-present unsplash">
                            <img src="static/images/emptyList.svg" class="no-data-img">
                            <span class="no-data-caption">Search to show content!</span>
                        </div>`
    $imageUploadModal.find('.image-listing.icon-finder .uploaded-images').html($loader)
    var searchTerm = $imageUploadModal.find('.image-listing.icon-finder .image-modal-head .search-box input').val();
    if (searchTerm)
      fnFetchIconFinderImages(searchTerm);
    else
      $imageUploadModal.find('.image-listing.icon-finder .uploaded-images').html($empty)
  })

  $imageUploadModal.find('.image-listing .search-box .close-icon').click(function () {
    let $parentImgListing = $(this).parents(".image-listing ")
    $(this).addClass('hide');
    $parentImgListing.find('.search-box input.search-image').val("");
    $parentImgListing.find('.uploaded-images .image-tile').removeClass("hide");
    $parentImgListing.find('.no-data-present').addClass('hide');
    if ($parentImgListing.hasClass("gallery") || $parentImgListing.hasClass("documents")) {
      displyFilteredTile(allowedExtArr)
    }
  });


  $imageUploadModal.find('.import.url .image-url').change(function () {
    var url = $(this).val();
    $imageUploadModal.find('.add-image-icon img')[0].src = url;
  });

  $imageUploadModal.find('.left.image-dir .image-category:not(.upload)').click(function () {
    if (!$(this).hasClass('selected')) {
      $imageUploadModal.find('.left.image-dir .image-category').removeClass('selected');
      $(this).addClass('selected');
      if ($(this).hasClass('gallery')) {
        $imageUploadModal.find('.right.image-listing').addClass('hide')
        $imageUploadModal.find('.right.image-listing.gallery').removeClass('hide')
        $imageUploadModal.find('.image-listing.gallery .search-box input.search-image').keyup();
      } else if ($(this).hasClass('unsplash')) {
        $imageUploadModal.find('.right.image-listing').addClass('hide')
        $imageUploadModal.find('.right.image-listing.unsplash').removeClass('hide')
        $imageUploadModal.find('.image-listing.unsplash .search-box input.search-image').keyup();
      } else if ($(this).hasClass('icon-finder')) {
        $imageUploadModal.find('.right.image-listing').addClass('hide')
        $imageUploadModal.find('.right.image-listing.icon-finder').removeClass('hide')
        $imageUploadModal.find('.image-listing.icon-finder .search-box input.search-image').keyup()
      } else if ($(this).hasClass('documents')) {
        $imageUploadModal.find('.right.image-listing').addClass('hide')
        $imageUploadModal.find('.right.image-listing.documents').removeClass('hide')
        $imageUploadModal.find('.image-listing.documents .search-box input.search-image').keyup();
      }
    }
    // displyFilteredTile(allowedExtArr)
  })
}

var initializeUppy = function () {
  uppy = Uppy.Core({
    restrictions: {
      maxFileSize: 50000000,
      maxNumberOfFiles: 15,
      allowedFileTypes: ['image/*']
    },
    meta: { pertype: 'P' }
  })
    .use(Uppy.Dashboard, {
      id: 'Dashboard',
      inline: true,
      target: '#import-image',
      width: 708,
      maxWidth: 708,
      height: 500,
      maxHeight: 500,
      showProgressDetails: true,
      proudlyDisplayPoweredByUppy: false,
      metaFields: [
        { id: 'name', name: 'Name', placeholder: 'file name' }
      ],
      locale: {
        strings: {
          dropPaste: 'Drop files here, or %{browse}',
          browse: 'browse'
        }
      }
    })
    .use(Uppy.XHRUpload, { endpoint: `${hfPluginUrl.value}/api/file/fileupload`, method: 'post', formData: true, fieldName: 'file[]', headers: { 'authorization': `Bearer ${dbAuthToken}` } })
    .on('complete', (result) => {
      if (result.successful.length && (typeof (result.successful[0].response.body) !== "string")) {
        var newImg = []
        let newDoc = []
        for (var i = 0; i < result.successful.length; i++) {
          var data = {};
          let fileExt = result.successful[i].extension
          data["imageUrl"] = result.successful[i].response.body.image_url;
          data["filename"] = result.successful[i].meta.name;
          if (isImageFileUrl(fileExt)) {
            data["isImage"] = true
            newImg.push(data);
          } else {
            data['isImage'] = false
            data["fileIcon"] = getIconFromExt(fileExt)
            newDoc.push(data);
          }
        }
        if (newImg && newImg.length) {
          let $imageTiles = fnHandlebars('prepend-new-fileUrl', newImg);
          $imageUploadModal.find('.image-listing.gallery .image-list .uploaded-images').prepend($imageTiles);
          $imageUploadModal.find('.image-listing.gallery .search-box input.search-image').keyup();
          $imageUploadModal.find(".image-category.gallery").trigger("click")
        }
        if (newDoc && newDoc.length) {
          let $imageTiles = fnHandlebars('prepend-new-fileUrl', newDoc);
          $imageUploadModal.find('.image-listing.documents .image-list .uploaded-images').prepend($imageTiles);
          $imageUploadModal.find('.image-listing.documents .search-box input.search-image').keyup();
          $imageUploadModal.find(".image-category.documents").trigger("click")
        }
        if (result.failed.length === 0) {
          $imageUploadModal.find('.upload-pic-overlay').addClass('hide');
          uppy.reset()
        }
      }
    })

  //import image from link. needs uppy reference
  $imageUploadModal.find('.picture-upload-modal .import.url .import-link').click(function () {

    var imageUrl = $imageUploadModal.find('.picture-upload-modal .import.url input.image-url').val();
    $imageUploadModal.find('.picture-upload-modal .import.url .import-link').addClass('loading')

    var index = imageUrl.lastIndexOf("/") + 1;
    var filename = imageUrl.substr(index);
    fetch(imageUrl)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.blob();
        } else {
          throw Error(response.statusText);
        }
      })
      .then((blob) => {
        var uploadFile = true
        uppy.getFiles().forEach(function (e, i) {
          if (e.name == filename) {
            $imageUploadModal.find('.import.url .error-message').removeClass('hide').text(`Cannot add the duplicate file "${filename}", it is already imported!`)
            uploadFile = false;
          }
        })
        if (uploadFile) {
          uppy.addFile({
            name: filename,
            type: blob.type,
            data: blob // changed blob -> data
          })
          $imageUploadModal.find('.picture-upload-modal .upload-type.system').click()
          $imageUploadModal.find('.import.url .error-message').addClass('hide')
          $imageUploadModal.find('.picture-upload-modal .import.url input.image-url').val('');
          $imageUploadModal.find('.import.url .image-url').trigger('change');
        }
      })
      .catch(error => {
        $imageUploadModal.find('.import.url .error-message').removeClass('hide').text(error.message)
      });
    $imageUploadModal.find('.picture-upload-modal .import.url .import-link').removeClass('loading')
  });

  $imageUploadModal.find('.import-images').click(function () {
    var totalSelected = $imageUploadModal.find('.image-listing.import .image-tile.selected').length;
    $imageUploadModal.find('.import-images').addClass('loading');
    $imageUploadModal.find('.image-listing.import .image-tile.selected').each(function (i, elm) {
      var imageUrl = $(elm).data('url')
      var filename = $(elm).data('filename').split("/").join("");
      fetch(imageUrl)
        .then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            return response.blob();
          } else {
            throw Error(response.statusText);
          }
        })
        .then((blob) => {
          var uploadFile = true
          uppy.getFiles().forEach(function (e, i) {
            if (e.name == filename) {
              // shortcuts.toast("Cannot import duplicate file!", 800)
              uploadFile = false;
            }
          })
          if (uploadFile) {
            filename = `${filename}.${blob.type.substr(blob.type.lastIndexOf('/') + 1)}`
            uppy.addFile({
              name: filename,
              type: blob.type,
              data: blob // changed blob -> data
            })
          }
          if (totalSelected == (i + 1)) {
            $imageUploadModal.find('.image-listing.import .image-tile.selected').removeClass('selected');
            $imageUploadModal.find('.import-images').removeClass('loading').addClass('hide');
            $imageUploadModal.find('.upload-pic-overlay').removeClass('hide');
            $imageUploadModal.find('.picture-upload-modal .upload-type.system').click();
          }
        })
        .catch(error => {
          // shortcuts.toast(`Unable to import ${filename}! Please try again later!`, 800)
          if (totalSelected == (i + 1)) {
            $imageUploadModal.find('.image-listing.import .image-tile.selected').removeClass('selected');
            $imageUploadModal.find('.import-images').removeClass('loading').addClass('hide');
          }
          if (totalSelected == (i + 1) && Object.keys(uppy.getState().files).length > 0) {
            $imageUploadModal.find('.upload-pic-overlay').removeClass('hide');
            $imageUploadModal.find('.picture-upload-modal .upload-type.system').click()
          }
        });
    })
  })
}

var fnFetchUserImages = function () {
  var reqUrl = `${hfPluginUrl.value}/api/GetGallary?tokenkey=${dbAuthToken}`
  var onSuccess = function (respData) {
    fnManipulateAndDisplayData(respData);
  }
  var onAjaxError = function (e) {
    // shortcuts.toast("Unable to fetch images! Please try again!", 800)
  }
  commonFunction.fnAjaxRequest(reqUrl, 'GET', {}, onSuccess, onAjaxError);
}
var displyFilteredTile = function (arryForFilter) {
  arryForFilter = arryForFilter && arryForFilter.length ? arryForFilter : []
  arryForFilter = arryForFilter.map(element => { return element.replaceAll(".", "").toLowerCase() })
  if (arryForFilter && arryForFilter.length) {
    $imageUploadModal.find(".image-listing .image-tile").addClass("hide")
    $imageUploadModal.find(".image-tile").each(function (elm) {
      var url = $(this).data('url').split(".")
      var ext = url[url.length - 1]
      if (arryForFilter.includes(ext)) {
        $(this).removeClass("hide")
      }
    })
  } else {
    $imageUploadModal.find(".image-listing .image-tile").removeClass("hide")
  }
  let $parentListing = $imageUploadModal.find('.image-listing:not(.hide)');
  // handle empy content
  if ($parentListing.find('.uploaded-images .image-tile:not(.hide)').length == 0) {
    $parentListing.find('.no-data-present').removeClass('hide');
  } else {
    $parentListing.find('.no-data-present').addClass('hide');
  }
}

var fnManipulateAndDisplayData = function (data) {
  var imageDir = "https://dronamobilepublic.s3.amazonaws.com/"
  data.forEach(function (data, i) {
    var filename = data["file_name"];
    if (filename.lastIndexOf(".") !== -1)
      var unique_key = filename.slice(filename.lastIndexOf("_"), filename.lastIndexOf("."));
    else
      var unique_key = filename.slice(filename.lastIndexOf("_"));
    filename = filename.slice(filename.lastIndexOf("/") + 1).replace(unique_key, "");
    data["filename"] = filename;
    data["imageUrl"] = imageDir + data["file_name"];
    data["timestamp"] = moment(data["file_created_date"]).valueOf();
    if (isImageFileUrl(data["file_type"])) {
      data["isImage"] = true
    } else {
      data['isImage'] = false
      data["fileIcon"] = getIconFromExt(data["file_type"])
    }
  })
  data = sortByTimestamp(data);
  let allImageList = data.filter(function (item) { return item["isImage"] })
  let allDocList = data.filter(function (item) { return !item["isImage"] })
  let $imageTiles = fnHandlebars('image-upload-tiles', allImageList);
  let $DocTiles = fnHandlebars('image-upload-tiles', allDocList);
  $imageUploadModal.find('.image-listing.gallery .image-list .uploaded-images').html($imageTiles);
  $imageUploadModal.find('.image-listing.documents .image-list .uploaded-images').html($DocTiles);
  displyFilteredTile(allowedExtArr)

}

var getIconFromExt = function (fileExt) {
  switch (fileExt) {
    case "pdf":
      return `./static/images/Control Icons/pdfFile.svg`
      break;
    case "ppt":
      return `./static/images/Control Icons/ppt.svg`
      break;
    case "csv":
    case "xls":
    case "xlsx":
      return `./static/images/Control Icons/excel.svg`
      break;
    case "doc":
    case "docs":
    case "docx":
      return `./static/images/Control Icons/doc.svg`
      break;
    case "mkv":
    case "mp4":
      return `./static/images/Control Icons/video.svg`
      break;
    case "zip":
    case "rar":
      return `./static/images/Control Icons/zip.svg`
      break;
    case "mp3":
      return `./static/images/Control Icons/audio.svg`
      break;
    default:
      return `./static/images/Control Icons/url.svg`
      break;
  }
};
var isImageFileUrl = function (fileExt, arrfileUrl = "") {
  let imageExt = getImageExt()
  if (arrfileUrl && arrfileUrl.length) {
    return checkArryExt(arrfileUrl, imageExt)
  } else {
    if (imageExt.includes(fileExt)) {
      return true
    } else {
      return false
    }
  }
}
var isDocFileUrl = function (arrfileUrl) {
  let docExt = getDocExt()
  return checkArryExt(arrfileUrl, docExt)
}
var getDocExt = function () {
  let docExt = ["doc", "docm", "docx", "xls", "xls", "xltx", "xlsm", "xltm", "xlam", "xlsb", "ppt", "pptx", "potx", "ppsx", "csv", "pdf"]
  return docExt
}
var getImageExt = function () {
  let imageExt = ['png', "jpg", "jfif", "jpeg", "jfif", "svg", "gif", "tif"]
  return imageExt;
}
var isUppyMimeType = function (arrfileUrl) {
  let mimeTypExt = ['md', 'markdown', 'mp4', 'mp3', 'svg', 'jpg', 'png', 'gif', 'heic', 'heif', 'yaml', 'yml', 'csv', 'tsv', 'tab', 'avi', 'mks', 'mkv', 'mov', 'doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'xla', 'xlam', 'xlc', 'xlf', 'xlm', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx', 'xlw', 'txt', 'text', 'conf', 'log', 'pdf']
  return checkArryExt(arrfileUrl, mimeTypExt)
}
var checkArryExt = function (arrfileUrl, compareWithExt) {
  if (arrfileUrl && arrfileUrl.length) {
    let tempArrfileUrl = arrfileUrl.map(element => { return element.replaceAll(".", "").toLowerCase() })
    let commanFile = _.intersection(tempArrfileUrl, compareWithExt)
    return commanFile.length > 0
  } else {
    return false
  }

}

var sortByTimestamp = function (data) {
  return data.sort(function (a, b) {
    let row1 = a["timestamp"];
    let row2 = b["timestamp"];
    let comparison = 0;
    if (row1 > row2) {
      comparison = 1;
    } else if (row1 < row2) {
      comparison = -1;
    }
    return comparison * -1;
  });
}

var fnFetchUnsplashImages = function (category) {
  if (category == "")
    category = 'random';
  var fnSuccess = function (response) {
    response = JSON.parse(response);
    if (response["success"]) {
      var imgObj = []
      var data = response["data"];
      if (typeof data === "string")
        data = JSON.parse(data || "[]");
      data.results.forEach(function (elm, i) {
        var imgUrl = elm["urls"]["raw"];
        var index = imgUrl.lastIndexOf("/") + 1;
        var filename = imgUrl.substr(index).slice(0, 15);
        var rowData = {
          "raw": imgUrl,
          "thumbnail": elm["urls"]["thumb"],
          "filename": filename
        };
        imgObj.push(rowData)
      })
      var $imageTiles = fnHandlebars('unsplash-tiles', imgObj);
      $imageUploadModal.find('.image-listing.unsplash .image-list .uploaded-images').html($imageTiles);
      if ($imageUploadModal.find('.image-listing.import .image-tile.selected').length === 0)
        $imageUploadModal.find('.import-images').addClass('hide');
    } else {
      // shortcuts.toast("Unable to fetch images! Please try again!", 800)
    }
  }
  var fnError = function (err) {
    // shortcuts.toast("Unable to fetch images! Please try again!", 800)
  }
  var reqObj = {
    "query": category
  };
  commonFunction.fnAjaxRequest(
    'api/getUnsplashImages',
    'POST',
    reqObj,
    fnSuccess,
    fnError
  );
};

var fnFetchIconFinderImages = function (query) {
  function fetchImages() {
    var fnSuccess = function (response) {
      response = JSON.parse(response);
      if (response["success"]) {
        var data = response["data"];
        if (typeof data === "string")
          data = JSON.parse(data)
        var imgObj = [];
        data.icons.forEach(function (elm, i) {
          var index = 6;
          if ((elm.raster_sizes.length - 1) < index)
            index = elm.raster_sizes.length - 1;
          var url = elm.raster_sizes[index].formats[0].preview_url;
          var token = url.substr(url.lastIndexOf("/"));
          slashedUrl = url.replace(token, "");
          var filename = slashedUrl.substr(slashedUrl.length - 15);
          if (elm.is_premium) {
            url = url.replace("https://api.iconfinder.com/", "");
            url = "https://api.iconfinder.com/v3/" + url
          }
          imgObj.push({
            "thumbnail": url,
            "raw": url,
            "filename": filename
          })
        })
        var $imageTiles = fnHandlebars('unsplash-tiles', imgObj);
        $imageUploadModal.find('.image-listing.icon-finder .image-list .uploaded-images').html($imageTiles);
        if ($imageUploadModal.find('.image-listing.import .image-tile.selected').length === 0)
          $imageUploadModal.find('.import-images').addClass('hide');
      } else {
        // shortcuts.toast("Unable to fetch icons! Please try again!", 800)
      }
    }
    var fnError = function (error) {
      // shortcuts.toast("Unable to fetch icons! Please try again!", 800)
    }
    var reqObj = {
      query: query,
      offset: 0,
      count: 100
    };
    commonFunction.fnAjaxRequest(
      `api/getIcons`,
      'POST',
      reqObj,
      fnSuccess,
      fnError
    );
  }
  fetchImages();
  // $.ajax({
  //     method: 'GET',
  //     url: `api/getIcons`,
  //     success: function (response) {
  //         response = JSON.parse(response);
  //         if (response["success"]) {
  //             var data = response["data"];
  //             if (typeof data === "string")
  //                 data = JSON.parse(data)
  //             var imgObj = [];
  //             data.icons.forEach(function (elm, i) {
  //                 var index = 6;
  //                 if ((elm.raster_sizes.length - 1) < index)
  //                     index = elm.raster_sizes.length - 1;
  //                 var url = elm.raster_sizes[index].formats[0].preview_url;
  //                 var token = url.substr(url.lastIndexOf("/"));
  //                 slashedUrl = url.replace(token, "");
  //                 var filename = slashedUrl.substr(slashedUrl.length - 15);
  //                 imgObj.push({
  //                     "thumbnail": url,
  //                     "raw": url,
  //                     "filename": filename
  //                 })
  //             })
  //             var $imageTiles = fnHandlebars('unsplash-tiles', imgObj);
  //             $imageUploadModal.find('.image-listing.icon-finder .image-list .uploaded-images').html($imageTiles);
  //             if ($imageUploadModal.find('.image-listing.import .image-tile.selected').length === 0)
  //                 $imageUploadModal.find('.import-images').addClass('hide');
  //         } else {
              // shortcuts.toast("Unable to fetch icons! Please try again!", 800)
  //         }
  //     },
  //     error: function (error) {
          // shortcuts.toast("Unable to fetch icons! Please try again!", 800)
  //         // if (error.status == 401) {
  //         //     fetchJwtToken()
  //         // } else {
          //     shortcuts.toast("Unable to fetch icons! Please try again!", 800)
  //         // }
  //     },
  // beforeSend: function (request) {
  //     request.setRequestHeader("Authorization", `Bearer haMbEYu6gioZ9YXDuSw6kpjqayIHi2O6OZzcY6gCW71C7WUrrFKijTthiC2KY7OD`);
  // }
  // });
  // function fetchJwtToken() {
  //     var reqData = { "operation": "getJwtTokenForIconFinder" }
  //     var onSuccess = function (data) {
  //         if (data !== "") {
  //             jwtAuthToken = data;
  //             fetchImages();
  //         }
  //     }
  //     var onError = function (err) {
          // shortcuts.toast("Unable to fetch icons! Please try again!", 800)
  //     }
  //     fnAjaxRequest('/Handler/studioConsole.ashx', 'GET', reqData, onSuccess, onError);
  // }
  // if (jwtAuthToken == undefined) {
  //     fetchJwtToken();
  // } else {
  //     fetchImages();
  // }
}

var initializeImageUpload = function () {
  appendHtml();
  clickEventInit();
  initializeUppy();
  fnFetchUserImages();
  fnFetchUnsplashImages('');
  editor.studioAssetManager.render = true;
};

var fnSelectImages = function (successCallback, errCallback, options) {
  if (!fetched) {
    fnFetchUserImages();
    fnFetchUnsplashImages('');
    fetched = true
  }
  $imageUploadModal.removeClass('hide')
  var maxLimit = 10;
  if (options.multiple && typeof (options["max-limit"]) == "number")
    maxLimit = options["max-limit"];
  else
    maxLimit = 1;
  $imageUploadModal.off('click', '.image-listing.gallery .image-tile:not(.selected)').on('click', '.image-listing.gallery .image-tile:not(.selected)', function () {
    if (maxLimit > 0) {
      var alreadySelected = $imageUploadModal.find('.image-listing.gallery .image-tile.selected');
      if (maxLimit == 1) {
        $(alreadySelected).removeClass('selected');
        $(this).addClass('selected');
      }
      else {
        if (alreadySelected.length < maxLimit) {
          $(this).addClass('selected');
        }
        else {
          // shortcuts.toast("Max limit reached!", 800)
        }
      }
      $imageUploadModal.find('.copy-images').removeClass('hide');
    }
  })
  $imageUploadModal.off('click', '.image-listing.gallery .image-tile.selected').on('click', '.image-listing.gallery .image-tile.selected', function () {
    $(this).removeClass('selected');
    if ($imageUploadModal.find('image-listing.gallery .image-tile.selected').length == 0)
      $imageUploadModal.find('.copy-images').addClass('hide');
  })
  $imageUploadModal.off('click', '.image-listing.documents .image-tile:not(.selected)').on('click', '.image-listing.documents .image-tile:not(.selected)', function () {
    if (maxLimit > 0) {
      var alreadySelected = $imageUploadModal.find('.image-listing.documents .image-tile.selected');
      if (maxLimit == 1) {
        $(alreadySelected).removeClass('selected');
        $(this).addClass('selected');
      }
      else {
        if (alreadySelected.length < maxLimit) {
          $(this).addClass('selected');
        }
        else {
          // shortcuts.toast("Max limit reached!", 800)
        }
      }
      $imageUploadModal.find('.copy-images').removeClass('hide');
    }
  })
  $imageUploadModal.off('click', '.image-listing.documents .image-tile.selected').on('click', '.image-listing.documents .image-tile.selected', function () {
    $(this).removeClass('selected');
    if ($imageUploadModal.find('image-listing.documents .image-tile.selected').length == 0)
      $imageUploadModal.find('.copy-images').addClass('hide');
  })
  $imageUploadModal.off('click', '.image-listing.import .image-tile:not(.selected)').on('click', '.image-listing.import .image-tile:not(.selected)', function () {
    var alreadySelected = $imageUploadModal.find('.image-listing.import .image-tile.selected').length;
    if (alreadySelected < 10) {
      $(this).addClass('selected');
    } else {
      // shortcuts.toast("You can only import 10 files at once!", 800)
    }
    $imageUploadModal.find('.import-images').removeClass('hide');
  })
  $imageUploadModal.off('click', '.image-listing.import .image-tile.selected').on('click', '.image-listing.import .image-tile.selected', function () {
    $(this).removeClass('selected');
    if ($imageUploadModal.find('.image-listing.import .image-tile.selected').length == 0)
      $imageUploadModal.find('.import-images').addClass('hide');
  })
  $imageUploadModal.off('click', '.copy-images.function-btn').on('click', '.copy-images.function-btn', function () {
    var links;
    let $parentImgListing = $(this).parents(".image-listing")
    if (options.multiple) {
      var data = []
      $parentImgListing.find('.image-tile.selected').each(function (i, elm) {
        data.push($(elm).data('url'))
      })
      links = data;
    } else {
      links = $imageUploadModal.find('.image-tile.selected').data('url')
    }
    if (links) {
      successCallback(links);
    } else {
      errCallback("some error")
    }
  })
  $imageUploadModal.off('click', '.copy-images.copy-link').on('click', '.copy-images.copy-link', function () {
    var links;
    let $parentImgListing = $(this).parents(".image-listing")
    if (options.multiple) {
      var data = []
      $parentImgListing.find('.image-tile.selected').each(function (i, elm) {
        data.push($(elm).data('url'))
      })
      links = data;
    } else {
      links = $imageUploadModal.find('.image-tile.selected').data('url')
    }
    if (links) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = links;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      // shortcuts.toast("Copied to clipboard", 800)
    } else {
      // shortcuts.toast("Unable to copy", 800)
    }
  })

  // restriction for all file type 
  uppyFileRestriction(options)
}
var uppyFileRestriction = function (options) {
  let allowedFiles = checkRestrictionType(options)
  allowedFiles = allowedFiles && allowedFiles.length ? allowedFiles : null
  uppy.setOptions({
    restrictions: { allowedFileTypes: allowedFiles }
  })
}
var checkRestrictionType = function (opt) {
  let rstType =
    opt && opt.fileRestritions && opt.fileRestritions.restrictionType
      ? opt.fileRestritions.restrictionType
      : '';
  switch (rstType) {
    case "onlyImage":
      let imgType = ['image/*', '.OTF', '.TTF', '.WOFF', '.WOFF2']
      hideAllFileTile()
      showImageFileTile()
      $imageUploadModal.find(".image-category.gallery").trigger("click")
      allowedExtArr = getImageExt()
      displyFilteredTile(allowedExtArr)
      return imgType
      break;
    case "OnlyDocFile":
      let docType = [".DOC", ".DOCM", ".DOCX", ".XLS", ".XLS", ".XLTX", ".XLSM", ".XLTM", ".XLAM", ".XLSB", ".PPT", ".PPTX", ".POTX", ".PPSX", ".CSV", ".PDF"]
      hideAllFileTile()
      showDocFileTile()
      $imageUploadModal.find(".image-category.documents").trigger("click")
      allowedExtArr = getDocExt()
      displyFilteredTile(allowedExtArr)
      return docType
      break;
    case 'allowSpecific':
      // let allowedFile = opt?.fileRestritions?.allowedFiles || []
      let allowedFile =
        opt && opt.fileRestritions && opt.fileRestritions.allowedFiles
          ? opt.fileRestritions.allowedFiles
          : [];
      if (allowedFile && allowedFile.length) {
        allowedFile = isUppyMimeType(allowedFile) ? allowedFile : null
      } else {
        allowedFile = getDefaultExtForUppy()
      }
      allowedExtArr = allowedFile
      displyFilteredTile(allowedExtArr)
      showSpecificFileTile(allowedFile)
      return allowedFile
      break;
    default:
      let defaultFileType = getDefaultExtForUppy()
      showDefaultFileTile()
      allowedExtArr = []
      displyFilteredTile(allowedExtArr)
      return defaultFileType;
      break;
  }

}
var getDefaultExtForUppy = function () {
  let docExt = [".DOC", ".DOCM", ".DOCX", ".XLS", ".XLS", ".XLTX", ".XLSM", ".XLTM", ".XLAM", ".XLSB", ".PPT", ".PPTX", ".POTX", ".PPSX", ".CSV", ".PDF", ".XML", ".JSON"]
  let imgExt = ['image/*', '.OTF', '.TTF', '.WOFF', '.WOFF2']
  return _.union(docExt, imgExt)
}
var showSpecificFileTile = function (allowedFile) {
  hideAllFileTile()
  let isDocFile = isDocFileUrl(allowedFile)
  let isImageFile = isImageFileUrl("", allowedFile)
  let isUppyMimeFile = isUppyMimeType(allowedFile)
  if (isUppyMimeFile) {
    if (isImageFile || isDocFile) {
      if (isDocFile) {
        showDocFileTile()
        $imageUploadModal.find(".image-category.documents").trigger("click")
      }
      if (isImageFile) {
        showImageFileTile()
        $imageUploadModal.find(".image-category.gallery").trigger("click")
      }
    } else {
      showDocFileTile()
      showImageFileTile()
      $imageUploadModal.find(".image-category.gallery").trigger("click")
    }
  } else {
    showDocFileTile()
    showImageFileTile()
    $imageUploadModal.find(".image-category.gallery").trigger("click")
  }
}
var showDefaultFileTile = function () {
  hideAllFileTile()
  showImageFileTile()
  showDocFileTile()
  $imageUploadModal.find(".image-category.gallery").trigger("click")

}
var showDocFileTile = function () {
  $imageUploadModal.find(".image-category.documents").removeClass("hide")

}
var hideAllFileTile = function () {
  $imageUploadModal.find(".image-listing").addClass("hide")
  $imageUploadModal.find(".image-category").addClass("hide")
  $imageUploadModal.find(".image-category").removeClass("selected")
  $imageUploadModal.find(".image-category.upload").removeClass("hide")
}
var showImageFileTile = function () {
  $imageUploadModal.find(".image-category.gallery").removeClass("hide")
  $imageUploadModal.find(".image-category.unsplash").removeClass("hide")
  $imageUploadModal.find(".image-category.icon-finder").removeClass("hide")

}
var fnCloseModal = function () {
  $imageUploadModal.addClass('hide');
  $imageUploadModal.find('.image-listing.gallery .image-tile.selected').removeClass('selected')
}
var fnHandlebars = function (tempId, data) {
  tempId = '#' + tempId;
  if (typeof data == 'string') {
    data = JSON.parse(data);
  }

  var tempHTML = $(tempId).html();

  var fnHandle = Handlebars.compile(tempHTML);
  return fnHandle(data);
};



export default {
  init: initializeImageUpload,
  selectImages: fnSelectImages,
  close: fnCloseModal
};
